import { render, staticRenderFns } from "./ObjetivosWindowLB.vue?vue&type=template&id=0785865e&scoped=true&"
import script from "./ObjetivosWindowLB.vue?vue&type=script&lang=js&"
export * from "./ObjetivosWindowLB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0785865e",
  null
  
)

export default component.exports